document.addEventListener('DOMContentLoaded',()=>{
    console.log('cart page script loaded');

    $('.item-meteryard').each(function(index,item){
       var max = Number($(item).find('.ds-cart-qty').attr('max'));
       var qtyCheck = Number($(item).find('.ds-cart-qty').val())
        if (max >= 100 && qtyCheck <= max) {


            $(item).find('button.plus').on('click', function(e) {
            var atcQty = Number($(item).find('.ds-cart-qty').val());
            if (atcQty >= 250) {
                e.preventDefault();
                e.stopPropagation();
                $(item).find('.ds-cart-qty').attr('step', '25');
                $(item).find('.ds-cart-qty').val(atcQty + 25);
                $(item).find('.ds-cart-qty').trigger('change');
        
            } else {
                $(item).find('.ds-cart-qty').attr('step', '50');
            }

            })

            $(item).find('button.minus').on('click', function(e) {
                var atcQty = Number($(item).find('.ds-cart-qty').val());
            if (atcQty > 250) {
                e.preventDefault();
                e.stopPropagation();
                $(item).find('.ds-cart-qty').val(atcQty - 25);
                $(item).find('.ds-cart-qty').trigger('change');
                $(item).find('#ds-cart-qty').text(Number($('.ds-cart-qty').val())/100.0)
                
            } else {
                $(item).find(' .ds-cart-qty').attr('step', '50');
            }
            })

        }
    
        $(item).find('.ds-cart-qty').on('change', function(e) {
            $(item).find('#ds-cart-qty').text(Number($(this).val())/100.0);
        })
    })

    $('.cart_item').each(function(index,item){
        $(item).find('.qty_cart_js').on('change', function(e) {
            var dsqty = Number($(this).val());
            var calculatedAmmount = (Number($(item).find('.ds-cart-page-price').data('orignalprice'))/100);
            var calculatedTotal = (calculatedAmmount * dsqty);
            $(item).find('.ds-cart-pricee').html(`RS. ${Math.ceil(calculatedTotal)}`);
        })
    })



})